import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import type { Field } from '../../model/formBuilderInterface';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { ValidationErrorsComponent } from '../validation-errors/validation-errors.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-custom-multiselect',
  templateUrl: './custom-multiselect.component.html',
  styleUrls: ['./custom-multiselect.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule,
    CheckboxModule,
    ReactiveFormsModule,
    ValidationErrorsComponent
  ]
})
export class CustomMultiSelectComponent implements OnInit {
  @Input() field: Field;
  @Input() form: FormGroup;
  searchTerm: string = '';
  allSelected = false;
  currentOptions;
  allOptions = []; // full source
  filteredOptions = []
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.allOptions = this.field?.options || [];
    this.filteredOptions = this.field?.options || [];
    this.subscribeField();
  }

  subscribeField() {
    this.form
      .get(this.field.name)
      .valueChanges?.pipe(takeUntil(this.destroy$))
      .subscribe((val) => {
        if (val) {          
          if (val.length === this.field?.options?.length) {
            this.allSelected = true;
          } else {
            this.allSelected = false;
          }
        }

        this.allOptions = this.field?.options || this.allOptions;
        this.filterOptions();
      });
  }

  filterOptions() {
    const term = this.searchTerm?.toLowerCase().trim() || '';
    // Step 1: Filter options by search term
    const filtered = term
      ? this.allOptions.filter(opt =>
          opt[this.field.customMultiselectConfig.optionLabel]?.toLowerCase().includes(term)
        )
      : [...this.allOptions];
  
    // Step 2: Get selected option objects from form
    const selectedOptions: any[] = this.form.get(this.field.name)?.value || [];
  
    // Step 3: Merge filtered + selected, remove duplicates based on unique identifier (sk or pk) or fallback to optionLabel
    const seenIds = new Set();
    const combinedOptions = [...filtered, ...selectedOptions].filter(opt => {
      // Use sk as unique identifier if available, otherwise pk, otherwise fallback to label
      const uniqueId = opt?.sk || opt?.pk || opt?.[this.field.customMultiselectConfig.optionLabel];
      if (!uniqueId || seenIds.has(uniqueId)) return false;
      seenIds.add(uniqueId);
      return true;
    });
  
    this.filteredOptions = combinedOptions;
  }
  
  
  

  toggleAll(event: boolean) {
    this.allSelected = event;
    if (this.allSelected) {
      this.form.get(this.field.name).setValue(this.field.options);
    } else {
      this.form.get(this.field.name).setValue([]);
    }
  }

  confirm(multiSelect: any) {
    this.closeMultiSelect(multiSelect);
    if (this.field.callback) this.field.callback('confirm');
  }

  customBtnClick(multiSelect: any) {
    this.closeMultiSelect(multiSelect);
    if (this.field.callback) this.field.callback('custom');
  }

  closeMultiSelect(multiSelect: any) {
    multiSelect.hide();
  }
}
